/**
 * Social - LinkedIn - Share
 */
import React from 'react'

export type LinkedInShareProps = {
  mini: boolean
  title: string
  url: string
}

/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable-next-line import/prefer-default-export */
export const LinkedInShare = ({ mini, title, url }: LinkedInShareProps) => {
  const path = 'https://www.linkedin.com/shareArticle?'

  return (
    <a
      href={`${path}mini=${mini}&url=${url}&title=${title}&source=${url}`}
      target="linkedin"
    >
      <i className="fab fa-linkedin-in" />
    </a>
  )
}

LinkedInShare.defaultProps = {
  mini: true
}
